var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatetime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.5 12.2v-4H6.4v19.7c0 3.2 2.6 5.8 5.8 5.8h.6M12.7 4.8v5.6M28 4.8v5.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.8 27.7H26v-5.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 36.9,
    cy: 27.7,
    r: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M35.5 32.7c-2 2.9-5.5 4.8-9.3 4.6-5.9-.3-10.6-5.3-10.3-11.2.3-5.9 5.3-10.6 11.2-10.3 4.2.2 7.8 2.8 9.4 6.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetime);
export default __webpack_public_path__ + "static/media/datetime.c1847aeeffd623d973b77f4e7c8c5b96.svg";
export { ForwardRef as ReactComponent };